"use strict";
/**
 * Created on 07 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SelloutTerminationUploadedItem}.</p>
 *
 * @author JMe
 */


var SelloutTerminationUploadedItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutTerminationUploadedItemConverter, _DataObjectConverter_);

  function SelloutTerminationUploadedItemConverter() {
    _classCallCheck(this, SelloutTerminationUploadedItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationUploadedItemConverter).apply(this, arguments));
  }

  return SelloutTerminationUploadedItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutTerminationUploadedItemConverter = SelloutTerminationUploadedItemConverter;